import {validateAndInsertMyImage} from "../functions/functions";

export function set_expert_profile_image()
{
    let profilePicInput = document.querySelector("input.upload_profile_image");
    validateAndInsertMyImage( profilePicInput, {
        url : profilePicInput.dataset.url,
        action : profilePicInput.dataset.action,
        nonce : profilePicInput.dataset.nonce,
        theSize : 250
    } );
}